import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import {
  getFTTBSocialInternetDataPopup,
  getFTTBSocialInternetUrlEsia,
} from 'pages/Internet/store/selectors/socialInternetSelectors';
import { switchSocialInternetPopupVisible } from 'pages/Internet/store/actions';
import { PopupButton, PopupDescription, PopupText } from '../../components';

export const PopupTextConnected = compose(connect(
  (state) => ({
    children: getFTTBSocialInternetDataPopup(state).text,
    shouldRender: !!getFTTBSocialInternetDataPopup(state).text,
  }),
), withRenderFlag)(PopupText);

export const PopupTitleConnected = compose(
  connect(
    (state) => ({
      children: getFTTBSocialInternetDataPopup(state).title,
      shouldRender: !!getFTTBSocialInternetDataPopup(state).title,
      isTitle: true,
    }),
  ), withRenderFlag,
)(PopupText);

export const PopupDescriptionConnected = compose(connect(
  (state) => ({
    children: getFTTBSocialInternetDataPopup(state).description?.text,
    image: getFTTBSocialInternetDataPopup(state).description?.image,
    shouldRender: !!getFTTBSocialInternetDataPopup(state).description?.text,
  }),
), withRenderFlag)(PopupDescription);

export const PopupButtonConnected = compose(
  connect(
    (state) => ({
      url: getFTTBSocialInternetUrlEsia(state),
      children: getFTTBSocialInternetDataPopup(state).buttonText,
      shouldRender: !!getFTTBSocialInternetDataPopup(state).buttonText,
    }), {
      onClick: switchSocialInternetPopupVisible,
    },
  ), withRenderFlag,
)(PopupButton);
